import { StoryblokServerComponent, SbBlokData } from "@storyblok/react/rsc";
import { PageProps } from "@/types/component.types";

export default function Page({
  blok,
  language = "de"
}: {
  blok: PageProps,
  language?: "de" | "en"
}) {

  return (
    <>
      {blok.body?.map((nestedBlok: SbBlokData) => (
        <StoryblokServerComponent
          key={nestedBlok._uid}
          blok={nestedBlok}
          language={language}
        />
      ))}
    </>
  );
};